import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {TranslateManager} from '../../../../../../../common/translate/translate.manager';
import {MailingConfig, MailingRequest, MailingResponse} from "../entity/mailing-models";
import {Http} from "@angular/http";

@Injectable()
export class CustomerEmailService {

    private baseUrl = '/api/backoffice';
    private pathPrefix = 'mailing';

    constructor(private _http: Http,
                private _translateManager: TranslateManager) {
    }

    public sendApproveCustomerEmail(profileId: number, mailingRequest: MailingRequest): Observable<MailingResponse> {
        let url = `${this.baseUrl}/${this.pathPrefix}/customers/${profileId}/send-approve`;
        return this._http.post(url, mailingRequest).map(response => response.json());
    }

    public sendResetPasswordCustomerEmail(userId: number, mailingRequest: MailingRequest): Observable<MailingResponse> {
        let url = `${this.baseUrl}/${this.pathPrefix}/customers/clients/${userId}/send-reset`;
        return this._http.post(url, mailingRequest).map(response => response.json());
    }

    public getMailingConfigByProfile(profileId: number): Observable<MailingConfig> {
        let url = `${this.baseUrl}/${this.pathPrefix}/configs/customers/profile/${profileId}`;
        return this._http.get(url).map(response => response.json());
    }

    public getMailingConfigByUser(userId: number): Observable<MailingConfig> {
        let url = `${this.baseUrl}/${this.pathPrefix}/configs/clients/${userId}`;
        return this._http.get(url).map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/customer.email.service.ts